import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { ArrowRightCircle, ChevronRight } from "lucide-react"
import { McPill } from "./McPill"

interface HandoffCardProps {
  items: string[]
}

export function HandoffCard({ items }: HandoffCardProps) {
  const { translate } = useTranslation()

  return (
    <div className="mt-[18px] rounded-md border border-purple1/30 bg-purple1/5 p-4">
      <div className="mb-2.5 flex items-center gap-2.5">
        <ArrowRightCircle size={16} className="shrink-0 text-purple1" />
        <div className="text-[12.5px] font-semibold text-white">
          {translate("MC_DECL_HANDOFF_TITLE")}
        </div>
        <McPill tone="muted">{translate("MC_DECL_HANDOFF_MODULE")}</McPill>
      </div>
      <div className="mb-2 text-[12px] text-grey5">
        {translate("MC_DECL_HANDOFF_BODY")}
      </div>
      <ul className="m-0 flex list-none flex-col gap-1 p-0">
        {items.map((item) => (
          <li
            key={item}
            className="flex items-start gap-2 text-[12.5px] text-white"
          >
            <ChevronRight
              size={12}
              className="mt-[3px] shrink-0 text-purple1"
            />
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
